/* eslint-disable @next/next/no-img-element */
// @ts-nocheck
import React from 'react';
import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
// @ts-ignore
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import BlogLink from 'components/blog/BlogLink';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/daymade-has-planted-1-million-trees`;

  return (
    <MainLayout additionalClassName="blogPost">
      <NextSeo
        title="DAYMADE Plants 1 Million Trees | DAYMADE"
        description="DAYMADE has reached an incredible milestone in our partnership with the Eden Reforestation Project, by planting 1 MILLION Trees. Our players have helped us build a sustainable and greener future by playing our Weekly Draws. Plant a tree today."
        openGraph={{
          title: 'DAYMADE Plants 1 Million Trees | DAYMADE',
          description:
            'DAYMADE has reached an incredible milestone in our partnership with the Eden Reforestation Project, by planting 1 MILLION Trees. Our players have helped us build a sustainable and greener future by playing our Weekly Draws. Plant a tree today.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/1-million-trees-planted',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'Mother and daughter walking through a forest',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'Eden Reforestation Project,daymade,plant trees',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Mother and daughter walking through a forest"
        heroImageYPosition="0%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            DAYMADE Has Planted 1 MILLION Trees!
          </h1>

          <p className="subheading">
            Making a true difference by planting one tree at a time
          </p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Violet Currey
          </p>

          <p>
            We have some very exciting news to share with you. Drum roll,
            please…
          </p>
          <br />

          <strong className="w-full text-left">
            We did it! 1 MILLION Trees Planted and Counting!
          </strong>
          <br />

          <p>
            We are thrilled to announce that DAYMADE has reached an incredible
            milestone in our partnership with the Eden Reforestation Project.
            With the help of our fantastic community of players who have planted
            1 MILLION trees through our Weekly Draws, we have helped make the
            planet a little bit greener! We couldn't be more proud and want to
            take this moment to thank you all SO MUCH for making this happen! 1
            Million trees, that's definitely A LOT! That's the same number as
            the population of Birmingham or all of the buildings in New York
            City (fun facts!), so it’s worth celebrating. We want to share with
            you what that exactly means and how our players have helped us make
            a true difference.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="Two women planting trees"
            className="singleBlogImage"
          />

          <h2>Our Work With The Eden Reforestation Project</h2>

          <p>
            By planting 1 MILLION trees, our players have contributed to
            restoring forests and supporting wildlife whilst providing
            opportunities for the local communities across nine nations.
          </p>
          <p>
            <BlogLink external="https://www.edenprojects.org/">
              The Eden Reforestation Project's
            </BlogLink>{' '}
            tree-planting programs support communities that have suffered damage
            to their local areas from deforestation and natural disasters caused
            by climate change. Our contributions have not only helped to restore
            our forests but have also empowered the locals with employment and
            education opportunities. This allows local farmers and their
            families to have a safe future in a protected world. Eden has
            success stories from locals in Brazil like{' '}
            <BlogLink external="https://www.edenprojects.org/stories/elienes-story/">
              Eliene
            </BlogLink>
            , who now earn a fair and consistent wage to live a better life. Or{' '}
            <BlogLink external="https://www.edenprojects.org/stories/nimas-story/">
              Nima
            </BlogLink>
            , who lost her hotel business in Nepal due to the COVID-19 pandemic.
            By working with the restoration project, she is improving the
            environment for her local community and receives secure employment
            so she can provide for her family. By{' '}
            <BlogLink internal="/giving-back">giving back</BlogLink> through The
            Eden Reforestation Project, we're helping to overcome the challenges
            that our planet faces whilst supporting local communities by
            planting one tree at a time.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="A worker from Eden Reforestation Project"
            className="singleBlogImage"
          />

          <h2>DAYMADE’s Top Tree Planters</h2>

          <p>
            We want to invite every player who has been part of our
            tree-planting journey to celebrate with us. Our work with Eden
            Reforestation was only possible with our dedicated players who share
            their love for what we do. We want to give an extra special
            shout-out to our top tree planters. Katherine Bull who has planted a
            whopping 493 trees, followed up by Carla Link who has planted 548
            trees which is incredible. Our no.1 tree planter spot goes to
            Bethany Sciberras for planting 571 since joining DAYMADE. Thank you
            Katherine, Carla and Bethany SO much! We can’t wait for our
            community of tree lovers to continue playing our Weekly Draws and
            helping our planet on the way. We not only have some very happy
            players who have won some epic prizes with us but we’ve also helped
            to make our planet happy too.
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="A farmer planting trees"
            className="singleBlogImage"
          />

          <h2>What's next?</h2>

          <p>
            This is just the beginning. Our journey towards a greener world
            continues, and we won't stop here. We are more determined than ever
            to keep planting trees, nourishing the Earth, and creating
            opportunities for local communities. Our 1 MILLION trees planted
            couldn't be done without our players, and we hope to continue
            growing the heroes of nature for future generations. Join us by
            playing our Weekly Draws with a chance to win epic prizes and make a
            difference. With every purchase, we'll plant a tree so you can be
            part of our next milestone of 2 MILLION - stay tuned. Thank you for
            being a part of our community and joining us on this extraordinary
            adventure.
          </p>

          <Separator
            style={{ margin: '1em 0 2.5em' }}
            id={undefined}
          />

          <p>Plant a tree today by entering our Weekly Draw.</p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px', margin: '1em 0 1.5em' }}
          >
            Plant a Tree
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
